import { Api } from "../axios-config";

export interface IComparacaoSemanaAnterior {
    qtdeAtual: number,
    diferencaPor: string,
    msgErro?: string
}

export interface IGrafico {
    nome: string[],
    qtde: number[]
}

export enum TipoAcao {
    Cadastro = 'Cadastro',
    Indexacao = 'Indexacao',
    AlteracaoIndice = 'AlteracaoIndice',
}

export const OPCOES_TIPO_ACAO: { value: TipoAcao, label: string }[] = [
    { value: TipoAcao.Cadastro, label: 'Cadastro' },
    { value: TipoAcao.Indexacao, label: 'Indexação' },
    { value: TipoAcao.AlteracaoIndice, label: 'Alteração de Índice' },
];

const gerarRelatorio = async (ano: number, cnpj?: string | null): Promise<number[] | Error> => {
    if (cnpj === undefined || cnpj === null) {
        cnpj = "";
    }
    try {
        const { data } = await Api.get(`Documento/relatorioMensal?ano=${ano}&cnpj=${cnpj}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao consutar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao consultar o registro');
    }
}

const comparacaoSemanaAnterior = async (cnpj?: string | null): Promise<IComparacaoSemanaAnterior | Error> => {
    if (cnpj === undefined || cnpj === null) {
        cnpj = "";
    }
    try {
        const { data } = await Api.get(`Documento/comparacaoSemanaAnterior?cnpj=${cnpj}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao consutar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao consultar o registro');
    }
}

const downloadRelatorioMensal = async (mes: string, ano: string, cnpj?: string | null): Promise<void | Error> => {
    try {
        if (cnpj === undefined || cnpj === null) {
            cnpj = "";
        }
        const { data } = await Api.get(`Documento/DownloadRelatorio?ano=${ano}&mes=${mes}&cnpj=${cnpj}`, { responseType: 'blob' });
        if (data) {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Relatório_${mes}-${ano}.csv`);
            document.body.appendChild(link);
            link.click();
        } else {
            return new Error('Erro ao consutar o registro');
        }

    } catch (error) {
        if ((error as { message: string }).message === "[object Blob]") {
            var meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
            (error as { message: string }).message = `Sem registros em ${meses[Number(mes) - 1]} de ${ano} encontrados`
        }
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao consultar o registro');
    }
}

const downloadRelatorioGeral = async (cnpj?: string | null): Promise<string | Error> => {
    try {
        if (cnpj === undefined || cnpj === null) {
            cnpj = "";
        }
        const { data } = await Api.get(`Documento/RelatorioDocumentos?cnpj=${cnpj}`);

        return data?.mensagem || 'Geração do relatório iniciada. Você receberá um e-mail com o link para download quando estiver pronto.';
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao consultar o registro');
    }
}

const downloadRelatorioGeralNaoIndexado = async (cnpj?: string | null): Promise<string | Error> => {
    try {

        var url = `Documento/RelatorioNaoIndexados`
        if (cnpj !== undefined && cnpj !== null && cnpj !== "") {
            url = `Documento/RelatorioNaoIndexados?cnpj=${cnpj}`;
        }

        const { data } = await Api.get(url);

        return data?.mensagem || 'Geração do relatório iniciada. Você receberá um e-mail com o link para download quando estiver pronto.';
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao consultar o registro');
    }
}

const downloadRelatorioGeralCaixas = async (cnpj?: string | null): Promise<void | Error> => {
    try {
        let url = `Caixa/relatorioCaixas`;

        if (cnpj !== undefined && cnpj !== null && cnpj !== "") {
            url = `Caixa/relatorioCaixas?cnpj=${cnpj}`;
        }

        // Configuração correta para receber um blob
        const response = await Api.post(url, null, { responseType: 'blob' });

        // Criação do link para download
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        const urlBlob = window.URL.createObjectURL(blob);

        link.href = urlBlob;
        link.setAttribute('download', `Relatório_Geral_de_Caixas.xlsx`);
        document.body.appendChild(link);
        link.click();

        // Remove o link depois do download
        link.parentNode?.removeChild(link);
        window.URL.revokeObjectURL(urlBlob);
    }
    catch (error) {
        // Tratamento de erro aprimorado
        const message = error instanceof Error ? error.message : 'Erro ao consultar o registro';
        console.error(message);
        return new Error(message);
    }
}


const graficoUsuario = async (cnpj: string, dataInicial: string | null, dataFinal: string | null, tipoAcao?: TipoAcao | ''): Promise<IGrafico | Error | undefined> => {
    try {
        let url = `Documento/RelatorioUsuario?cnpj=${cnpj}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`;
        if (tipoAcao) {
            url += `&tipoAcao=${tipoAcao}`;
        }

        const { data } = await Api.get(url);

        if (data) {
            return data;
        }

    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao consultar o registro');
    }
}

const downloadRelatorioIndexados = async (anoAtual: number, cnpj?: string | null): Promise<void | Error> => {
    try {
        var url = `Documento/RelatorioIndexados?ano=${anoAtual}`;
        if (cnpj !== undefined && cnpj !== null && cnpj !== "") {
            url = `Documento/RelatorioIndexados?ano=${anoAtual}&cnpj=${cnpj}`;
        }
        const { data } = await Api.get(url, { responseType: 'blob' });
        if (data) {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Relatório_Indexados${cnpj}.csv`);
            document.body.appendChild(link);
            link.click();
        }
        else {
            return new Error('Erro ao consutar o registro');
        }

    }
    catch (error) {
        if ((error as { message: string }).message === "[object Blob]") {
            (error as { message: string }).message = `Sem registros em encontrados`
        }
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao consultar o registro');
    }
}

const downloadIndexadosPorUsuario = async (cnpj: string | null | undefined, periodo: string | null, tipoAcao?: TipoAcao | ''): Promise<void | Error> => {
    try {
        var dataInicial = "";
        var dataFinal = "";

        if (periodo !== null && periodo !== "") {
            var datas = periodo.split(" | ");
            dataInicial = datas[0];
            dataFinal = datas[1];
        }

        let url = `Documento/RelatorioIndexadosPorUsuario?cnpj=${cnpj}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`;
        if (tipoAcao) {
            url += `&tipoAcao=${tipoAcao}`;
        }

        const { data } = await Api.get(url, { responseType: 'blob' });
        if (data) {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Relatório_Indexados_Por_Usuario_${cnpj}.csv`);
            document.body.appendChild(link);
            link.click();
        }
        else {
            return new Error('Erro ao consutar o registro');
        }

    }
    catch (error) {
        if ((error as { message: string }).message === "[object Blob]") {
            (error as { message: string }).message = `Sem registros em encontrados`
        }
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao consultar o registro');
    }
}

const gerarRelatorioCaixaPorIntervalo = async (mes: string, ano: string, cnpj?: string | null): Promise<void | Error> => {
    try {
        if (cnpj === undefined || cnpj === null) {
            cnpj = "";
        }
        
        const response = await Api.get(`Caixa/realtorioPorIntervalo?cnpj=${cnpj}&ano=${ano}&mes=${mes}`, { responseType: 'blob' });

        if (response) {
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            const urlBlob = window.URL.createObjectURL(blob);

            link.href = urlBlob;
            link.setAttribute('download', `Relatório_caixas_${mes}-${ano}.xlsx`);
            document.body.appendChild(link);
            link.click();

            // Remove o link depois do download
            link.parentNode?.removeChild(link);
            window.URL.revokeObjectURL(urlBlob);

        } else {
            return new Error('Erro ao consutar o registro');
        }
    } catch (error) {
        if ((error as { message: string }).message === "[object Blob]") {
            var meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
            (error as { message: string }).message = `Sem registros em ${meses[Number(mes) - 1]} de ${ano} encontrados`
        }
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao consultar o registro');
    }
}

export const HomeService = {
    gerarRelatorio,
    comparacaoSemanaAnterior,
    downloadRelatorioMensal,
    graficoUsuario,
    downloadRelatorioGeral,
    downloadRelatorioGeralCaixas,
    downloadRelatorioIndexados,
    downloadIndexadosPorUsuario,
    downloadRelatorioGeralNaoIndexado,
    gerarRelatorioCaixaPorIntervalo,
}